<template>
  <div class="sms-action-footer">
    <div class="close-sms-action" @click="$emit('closeAction')">
      <span class="close">close</span>
    </div>
    <slot name="footerRight"></slot>
  </div>
</template>

<script>
  export default {
    name: 'SmsActionFooter',
  }
</script>